import * as React from 'react';
import { useSelector } from 'react-redux';

import { trackHeadCategoryClick } from './tracking';
import { HeadCategories } from '../../components/HeadCategories';
import { selectHeadCategories } from '../../selectors/promosPage';
import { IHeadCategory } from '../../types/promosPage';

export const HeadCategoriesContainer: React.FC = () => {
  const categories = useSelector(selectHeadCategories);

  const handleClick = React.useCallback((category: IHeadCategory) => {
    trackHeadCategoryClick(category.name);
  }, []);

  return <HeadCategories categories={categories} onClick={handleClick} />;
};
